// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPIToolBarMenu = makeThemedStyles('KPIToolBarMenu', () => ({
  KPIToolBarMenu: {
    color: '#115e67',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '13px',
    fontWeight: 'bold'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPIToolBarMenu: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPIToolBarMenu();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPIToolBarMenu)}
    >
      {props?.children}
    </div>
  );
};
export default KPIToolBarMenu;
